module.exports = __webpack_public_path__ + "img/cf.755f94f4.svg";